export default __webpack_public_path__ + "static/media/clear3.50cd846e.mp3";